<div *ngIf="config">
  <mat-card
    class="gallery-card"
    [ngStyle]="{
      border: '1px solid ' + configs?.colors?.bot_message_border,
      background: configs?.colors?.bot_message_background,
      'font-size': '14px'
    }"
  >
    <mat-card-subtitle
      class="sub-title"
      [ngStyle]="{
        'font-family': configs?.fonts?.default_font,
        'font-size': '14px',
        color: configs?.colors?.bot_message_text
      }"
    >
      {{ messageText }}
    </mat-card-subtitle>
    <a [href]="config.video_url" target="_blank">
      <ng-container *ngIf="isYouTubeVideo(config.video_url); else regularVideo">
        <iframe
          [src]="getSanitizedYouTubeUrl(config.video_url)"
          frameborder="0"
          allowfullscreen
          class="gallery-video"
        ></iframe>
      </ng-container>
      <ng-template #regularVideo>
        <video
          mat-card-image
          class="gallery-video"
          [src]="config.video_url"
          controls
          allowfullscreen
          alt="video"
        ></video>
      </ng-template>
    </a>
  </mat-card>
  <div class="display-flex flex-space-between" style="width: 94%">
    <app-message-timestamp
      *ngIf="input.created_at && input.created_at > 0"
      [createdAt]="input.created_at"
    >
    </app-message-timestamp>
    <span
      class="unread"
      *ngIf="!isRead"
      [ngStyle]="{
                'color': configs?.colors?.user_message_background,
              }"
      >{{ messageUnreadText }}</span
    >
  </div>
</div>
